/* eslint-disable import/prefer-default-export */

import { Mutex } from '../utils';
import { SlugStorage, SlugStorageInfo } from './storage';

interface SimpleWebStorage {
  readonly length: number;
  key(index: number): string | null;

  getItem(key: string): string | null;
  removeItem(key: string): void;
  setItem(key: string, value: string): void;
  clear(): void;
}

// @Deprecated 如有必要，使用 proxyStorage
export class WebStorage implements SlugStorage {
  private m: Mutex;
  private ns?: string;
  private storage: SimpleWebStorage;
  public constructor(storage: SimpleWebStorage, ns?: string) {
    // TODO: log @Deprecated 如有必要，使用 proxyStorage
    this.m = new Mutex();
    this.ns = ns;
    this.storage = storage;
  }

  // WebStorage 独有
  public async setString(key: string, value: string): Promise<void> {
    this.storage.setItem(key, value);
  }
  public setStringSync(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  public async batchGet<T>(keys: string[]): Promise<{ [key: string ]: T | undefined }> {
    const values = await Promise.all<T | undefined>(keys.map(k => this.getItem(k)));
    const o: { [key: string ]: T | undefined } = {};
    keys.forEach((k, i) => o[k] = values[i]);
    return o;
  }
  public async batchSet<T>(data: { [key: string ]: T | undefined }): Promise<void> {
    await Promise.all(Object.keys(data).map(k => this.setItem(k, data[k])));
  }

  public async getItem<T>(key: string, defaultValue?: T): Promise<T | undefined> {
    return this.getItemSync<T>(key, defaultValue);
  }
  public async setItem<T>(key: string, value: T): Promise<void> {
    await this.m.Lock();
    this.setItemSync<T>(key, value);
    this.m.Lock();
  }
  public async remove<T>(key: string): Promise<T | undefined> {
    await this.m.Lock();
    const value = this.remove<T>(key);
    this.m.Lock();
    return value;
  }
  public async clear(): Promise<void> {
    await this.m.Lock();
    this.clear();
    this.m.Lock();
  }
  public async info(): Promise<SlugStorageInfo> {
    return this.infoSync();
  }

  public getItemSync<T>(key: string, defaultValue?: T): T | undefined {
    const { value } = this.getValueWithInfo(key);
    return value !== null ? (JSON.parse(value) as T) : defaultValue;
  }
  public setItemSync<T>(key: string, value?: T): void {
    if (value === undefined) {
      this.removeSync(key);
      return;
    }

    const v = JSON.stringify(value);
    this.storage.setItem(this.k(key), v); // 不一定生效
    const info = this.infoSync();
    info.keys = info.keys.filter(k => k !== key);
    info.keys.push(key);
    this.saveInfo(info); // 生效
  }
  public removeSync<T>(key: string): T | undefined {
    const { info, value } = this.getValueWithInfo(key);
    info.keys = info.keys.filter(k => k !== key);
    this.saveInfo(info); // 生效
    this.storage.removeItem(this.k(key)); // 清理
    return value !== null ? (JSON.parse(value) as T) : undefined;
  }
  public clearSync(): void {
    if (!this.ns) {
      return this.storage.clear();
    }
    const { keys } = this.infoSync();
    this.storage.removeItem(this.ns);
    keys.forEach(k => this.removeSync(k));
  }
  public infoSync(): SlugStorageInfo {
    if (!this.ns) {
      return {
        keys: Array(this.storage.length)
          .fill(undefined)
          .map((_, i) => this.storage.key(i))
          .filter(v => !!v) as string[],
      };
    }
    const value = this.storage.getItem(this.ns);
    if (!value) {
      return {
        keys: [],
      };
    }
    const info = JSON.parse(value) as SlugStorageInfo;
    return info;
  }

  private k(key: string) {
    return this.ns ? `${this.ns}.${key}` : key;
  }
  private saveInfo(info: SlugStorageInfo) {
    this.ns && this.storage.setItem(this.ns, JSON.stringify(info));
  }
  private getValueWithInfo(key: string): { value: string | null; info: SlugStorageInfo } {
    const info = this.infoSync();
    return {
      value: info.keys.includes(key) ? this.storage.getItem(this.k(key)) : null,
      info,
    };
  }
}

// export const localStorage = new WebStorage(window.localStorage);
// export const sessionStorage = new WebStorage(window.sessionStorage);
